import styled from 'styled-components'
import { ButtonLink } from '@chegg-ui/button-link'
import { Typography } from '@chegg-ui/typography'
import { font, colors, spacing, breakpoints } from '@chegg-ui/theme'
import { BANNER_TEXT_THEMES } from './constants'

const textMaxWidth = '496px'
const headingContainerHeight = '170px'
const bannerHeadingDesktopHeight = '88px'
const bannerHeadingDesktopWidth = '682px'
const bannerHeadingMobileWidth = '288px'
const HeadingButtonWidth = '155px'

export const InfoBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.px32};
  padding: 64px 0;
`

export const BannerContainer = styled.div<{
  backgroundColor: string
  isFlipped: boolean
}>`
  gap: ${spacing.px64};
  border-radius: ${spacing.px24};
  border: ${spacing.px4};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  align-items: center;
  padding: ${spacing.px48} ${spacing.px16};
  flex-direction: ${({ isFlipped }) => (isFlipped ? 'column-reverse' : 'column')};
  @media (min-width: ${breakpoints.md.max}) {
    padding: ${spacing.px48} ${spacing.px64};
    flex-direction: row;
  }
`

export const TextContainer = styled.div`
  box-sizing: border-box;
  gap: ${spacing.px40};
  display: flex;
  flex-direction: column;
  @media (min-width: ${breakpoints.md.max}) {
    gap: ${spacing.px64};
  }
`

export const TextContentContainer = styled.div`
  max-width: 100%;
  display: flex;
  gap: ${spacing.px24};
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${breakpoints.md.max}) {
    max-width: ${textMaxWidth};
  }
`

export const TextElement = styled.div`
  display: flex;
  gap: ${spacing.px24};
`

export const TextHeadingContainer = styled.div`
  max-width: ${textMaxWidth};
  max-height: 100%;
  gap: 20px;
  display: flex;
  flex-direction: column;
  padding-top: ${spacing.px12};
  @media (min-width: ${breakpoints.md.max}) {
    padding-top: 20px;
    max-height: ${headingContainerHeight};
  }
`

const getTextColorByTheme = (theme: string) =>
  theme === BANNER_TEXT_THEMES.WHITE ? colors.white : colors.grey900

const getButtonColorByTheme = (theme: string) =>
  theme === BANNER_TEXT_THEMES.WHITE ? colors.cheggOrange : colors.grey900

export const SubHeadingText = styled.p<{ textTheme: string }>`
  display: flex;
  gap: ${spacing.px4};
  color: ${({ textTheme }) => getTextColorByTheme(textTheme)};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.px14};
  line-height: ${font.lineHeight.sm};
  letter-spacing: 0.25px;
  > span {
    position: relative;
    bottom: 5px;
    padding: 10px 0 0 5px;
  }
`
export const HeadingText = styled.p<{ textTheme: string }>`
  color: ${({ textTheme }) => getTextColorByTheme(textTheme)};
  max-width: ${textMaxWidth};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.px20};
  line-height: ${font.lineHeight.md};
  @media (min-width: ${breakpoints.md.max}) {
    font-size: ${font.size.px30};
    line-height: 33px;
  }
`

export const TextContentHeading = styled.p<{ textTheme: string }>`
  color: ${({ textTheme }) => getTextColorByTheme(textTheme)};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.px20};
  line-height: ${font.lineHeight.md};
  padding-bottom: ${spacing.px12};
`

export const TextContent = styled.p<{ textTheme: string }>`
  color: ${({ textTheme }) => getTextColorByTheme(textTheme)};
  font-weight: ${font.weight.normal};
  font-size: ${font.size.px16};
  line-height: ${font.lineHeight.md};
`

export const HeadingButton = styled(ButtonLink)<{ textTheme: string }>`
  width: ${HeadingButtonWidth};
  :focus {
    outline-offset: 0;
    outline: 0;
  }
  && {
    background: ${({ textTheme }) => getButtonColorByTheme(textTheme)};
  }
`
export const InfoBannerHeading = styled(Typography).attrs({ variant: 'display6' })`
  max-width: ${bannerHeadingDesktopWidth};
  height: ${bannerHeadingDesktopHeight};
  margin-bottom: ${spacing.px32};
  > span {
    color: ${colors.cheggOrange};
  }
  @media (max-width: ${breakpoints.md.min}) {
    font-size: ${font.size.px22};
    line-height: 28px;
    max-width: ${bannerHeadingMobileWidth};
    height: ${spacing.px64};
    margin-bottom: 0;
  }
`
export const InfoBannerHeadingContainer = styled.div`
  height: 100%;
  width: 100%;
`
